<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Blog</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <blog-form :data="data"></blog-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import BlogForm from './BlogForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'BlogDialog',
  data() {
    return {
      data: {
        name: '',
        description: '',
        about: '',
        blogTypeSlug: '',
        active: false,
        file: null,
        image: null,
        fileLoading: false,
        categories: []
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'blogs', 'item'],
  components: {
    BlogForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting blog data for id ', this.item.id)
      axios
        .get('api/admin/blogs/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new blog')
      axios
        .post('api/admin/blogs/create', {
          name: this.data.name,
          description: this.data.description,
          about: this.data.about,
          active: this.data.active,
          categories: this.data.categories,
          blog_types_slug: this.data.blogTypeSlug.slug
        })
        .then(res => {
          console.log(res.data)
          console.log('done')

          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      console.log(
        'updating blog data for id ',
        this.item.id,
        this.data.description
      )
      axios
        .put(`api/admin/blogs/${this.item.id}`, {
          name: this.data.name,
          description: this.data.description,
          about: this.data.about,
          active: this.data.active,
          categories: this.data.categories,
          blog_types_slug: this.data.blogTypeSlug.slug
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        name: '',
        description: '',
        about: '',
        active: false,
        categories: [],
        blogTypeSlug: ''
      }
    }
  },
  watch: {
    'data.file': function(file) {
      this.fileLoading = true
      let formData = new FormData()
      let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
      if (file && this.data.name.length > 0) {
        console.log('uploading file')
        if (file.size < 5000000) {
          formData.append('file', file)
          formData.append('name', this.data.name)
          formData.append('model', 'blogs')
          if (this.data.id) {
            axios
              .post(
                `api/admin/blogs/${this.data.id}/upload-media`,
                formData,
                headers
              )
              .then(res => {
                this.data.image = res.data
                console.log(res.data)
                console.log('done')
                this.data.file = null
                this.fileLoading = false
              })
              .catch(err => console.log(err))
          } else {
            axios
              .post('api/admin/file-upload', formData, headers)
              .then(res => {
                this.data.image = res.data
                console.log(res.data)
                console.log('done')
                this.data.file = null
                this.fileLoading = false
              })
              .catch(err => console.log(err))
          }
        }
      }
    },
    data(val) {
      console.log(val.blogTypeSlug)
    }
  }
}
</script>

<style lang="scss" scoped></style>
